/*
Toggles class on element
@param el:          HTMLelement
@param className:   string    
*/
function toggleClass(el, className) {
  if (!el) return;

  if (el.classList.contains(className)) {
    el.classList.remove(className);
  } else {
    el.classList.add(className);
  }
}
